import {
  Container,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import Title from "../../components/Title";
import ButtonWithSpinner from "../../components/ButtonWithSpinner";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2, 2, 3),
  },
  paper: {
    padding: theme.spacing(1),
    marginBottom: 12,
  },
  integrationRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    gap: theme.spacing(2),
  },
  textFieldContainer: {
    position: "relative",
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  iconButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: "50%",
    transform: "translateY(-50%)",
  },
}));

const AjustesDesenvolvimento = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [codigoValido, setCodigoValido] = useState(false);

  const handleCalcularTempo = async () => {
    setLoading(true);
    try {
      const retornoCalculoTempoTicket = await api.put(
        "/ajustes-desenvolvimento-tempo-tickets"
      );

      if (retornoCalculoTempoTicket.status === 200) {
        toast.success("Tempos dos Tickets atualizados com sucesso!");
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error);
    }
  };

  const handleValidarCodigo = async () => {
    if (codigo === "123456") {
      setCodigoValido(true);
    }
  };

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <Title>{"Ajustes de Desenvolvimento"}</Title>
        <Paper className={classes.paper}>
          <div className={classes.integrationRow}>
            <Typography align="left" variant="body1">
              {"Atualizar os valores dos campos de tempo do Ticket"}
            </Typography>

            <ButtonWithSpinner
              variant="contained"
              onClick={handleCalcularTempo}
              color="primary"
              loading={loading}
              disabled={!codigoValido}
            >
              {"Atualizar tempos"}
            </ButtonWithSpinner>
            <TextField
              style={{ width: 100 }}
              id="codigo"
              name="codigo"
              label={"Código"}
              variant="outlined"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              inputProps={{ maxLength: 6 }}
              margin="dense"
              type="password"
            />
            <ButtonWithSpinner
              variant="contained"
              onClick={handleValidarCodigo}
              color="primary"
              loading={loading}
            >
              {"OK"}
            </ButtonWithSpinner>
          </div>
        </Paper>
      </Container>
    </div>
  );
};

export default AjustesDesenvolvimento;
